/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date custom scalar type */
  Date: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type AddressInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  alpha2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type Article = {
  __typename?: 'Article';
  _id?: Maybe<Scalars['ID']['output']>;
  content?: Maybe<ArticleContent>;
  created?: Maybe<Scalars['Date']['output']>;
  handle?: Maybe<Scalars['String']['output']>;
  homepage?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  modified?: Maybe<Scalars['Date']['output']>;
  private?: Maybe<Scalars['Boolean']['output']>;
  published?: Maybe<ArticlePublished>;
  seo?: Maybe<Seo>;
  tags: Array<Scalars['String']['output']>;
  thumbnail?: Maybe<Media>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ArticleType>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ArticleContent = {
  __typename?: 'ArticleContent';
  editor?: Maybe<Scalars['JSON']['output']>;
  html?: Maybe<Scalars['String']['output']>;
  rows: Array<ArticleContentRow>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ArticleContentBlock = {
  __typename?: 'ArticleContentBlock';
  data?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ArticleContentColumn = {
  __typename?: 'ArticleContentColumn';
  blocks: Array<ArticleContentBlock>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ArticleContentRow = {
  __typename?: 'ArticleContentRow';
  columns?: Maybe<Array<Maybe<ArticleContentColumn>>>;
  id?: Maybe<Scalars['ID']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  options?: Maybe<ArticleContentRowOptions>;
};

export type ArticleContentRowOptions = {
  __typename?: 'ArticleContentRowOptions';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  carousel?: Maybe<Scalars['Boolean']['output']>;
  fullWidth?: Maybe<Scalars['Boolean']['output']>;
  noPadding?: Maybe<Scalars['Boolean']['output']>;
};

export type ArticlePublished = {
  __typename?: 'ArticlePublished';
  date?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export enum ArticleType {
  Editor = 'editor',
  Html = 'html',
  Page = 'page',
  Post = 'post',
  Text = 'text'
}

export type Artist = {
  __typename?: 'Artist';
  _id: Scalars['ID']['output'];
  anvs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  country?: Maybe<ArtistCountry>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  discogsId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  images?: Maybe<Array<Maybe<ArtistImage>>>;
  members?: Maybe<Array<Maybe<ArtistMember>>>;
  modifiedAt?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  websites?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ArtistCountry = {
  __typename?: 'ArtistCountry';
  alpha2?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ArtistImage = {
  __typename?: 'ArtistImage';
  thumbnail?: Maybe<Scalars['String']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
};

export type ArtistMember = {
  __typename?: 'ArtistMember';
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BookIndustryIdentifier = {
  __typename?: 'BookIndustryIdentifier';
  identifier?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Checkout = {
  __typename?: 'Checkout';
  _id?: Maybe<Scalars['ID']['output']>;
  billing?: Maybe<CheckoutBilling>;
  buyer?: Maybe<CheckoutBuyer>;
  configRef?: Maybe<Scalars['ID']['output']>;
  created?: Maybe<Scalars['Date']['output']>;
  expires?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  items: Array<CheckoutLineItem>;
  message?: Maybe<Scalars['String']['output']>;
  note?: Maybe<CheckoutNote>;
  orderId?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  seller?: Maybe<CheckoutUser>;
  shipping?: Maybe<CheckoutShipping>;
  status?: Maybe<Scalars['String']['output']>;
  totals?: Maybe<CheckoutTotals>;
  updated?: Maybe<Scalars['Date']['output']>;
  urls?: Maybe<CheckoutUrls>;
};

export type CheckoutAddress = {
  __typename?: 'CheckoutAddress';
  _id?: Maybe<Scalars['ID']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  alpha2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CheckoutAddressInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  alpha2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CheckoutBilling = {
  __typename?: 'CheckoutBilling';
  address?: Maybe<CheckoutAddress>;
  invoice?: Maybe<CheckoutInvoice>;
  paymentDate?: Maybe<Scalars['Date']['output']>;
  paymentMethods?: Maybe<Array<Maybe<CheckoutPaymentMethod>>>;
  refundDate?: Maybe<Scalars['Date']['output']>;
  refunds?: Maybe<Array<Maybe<CheckoutPaymentMethod>>>;
  status?: Maybe<Scalars['String']['output']>;
  voucher?: Maybe<CheckoutVoucher>;
};

export type CheckoutBillingInput = {
  address?: InputMaybe<CheckoutAddressInput>;
  voucher?: InputMaybe<CheckoutVoucherInput>;
};

export type CheckoutBuyer = {
  __typename?: 'CheckoutBuyer';
  _id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  isGuest?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organisation?: Maybe<Scalars['String']['output']>;
  taxNumber?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
};

export type CheckoutBuyerInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  isGuest?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organisation?: InputMaybe<Scalars['String']['input']>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
};

export type CheckoutEmail = {
  __typename?: 'CheckoutEmail';
  date?: Maybe<Scalars['Date']['output']>;
  recipient?: Maybe<Scalars['String']['output']>;
};

export type CheckoutEmailInput = {
  recipient?: InputMaybe<Scalars['String']['input']>;
};

export type CheckoutInvoice = {
  __typename?: 'CheckoutInvoice';
  date?: Maybe<Scalars['Date']['output']>;
  emails?: Maybe<CheckoutEmail>;
  id?: Maybe<Scalars['String']['output']>;
  pdf?: Maybe<Scalars['String']['output']>;
};

export type CheckoutItem = {
  __typename?: 'CheckoutItem';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['String']['output']>;
};

export type CheckoutItemInput = {
  listingId: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
};

export type CheckoutLineItem = {
  __typename?: 'CheckoutLineItem';
  _id?: Maybe<Scalars['ID']['output']>;
  added?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  item?: Maybe<CheckoutItem>;
  listing?: Maybe<CheckoutListing>;
  price?: Maybe<CheckoutLinePrice>;
  quantity?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  unavailable?: Maybe<Scalars['Boolean']['output']>;
};

export type CheckoutLinePrice = {
  __typename?: 'CheckoutLinePrice';
  base?: Maybe<Scalars['Float']['output']>;
  beforeTaxes?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  subtotalBeforeTaxes?: Maybe<Scalars['Float']['output']>;
  taxes?: Maybe<Array<Maybe<CheckoutTax>>>;
};

export type CheckoutListing = {
  __typename?: 'CheckoutListing';
  _id?: Maybe<Scalars['String']['output']>;
  available?: Maybe<Scalars['Date']['output']>;
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  comments?: Maybe<Scalars['String']['output']>;
  discogsId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  onePerCustomer?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<CheckoutListingOption>>>;
  posted?: Maybe<Scalars['Date']['output']>;
  preOrder?: Maybe<Scalars['Boolean']['output']>;
  preventDiscogsListing?: Maybe<Scalars['Boolean']['output']>;
  prices?: Maybe<CheckoutListingPrice>;
  privateComments?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stock?: Maybe<CheckoutStock>;
  supplierCode?: Maybe<Scalars['String']['output']>;
  taxDefinition?: Maybe<Scalars['String']['output']>;
};

export type CheckoutListingOption = {
  __typename?: 'CheckoutListingOption';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CheckoutListingPrice = {
  __typename?: 'CheckoutListingPrice';
  base?: Maybe<Scalars['Float']['output']>;
  beforeTaxes?: Maybe<Scalars['Float']['output']>;
  compare?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['String']['output']>;
  sale?: Maybe<Scalars['String']['output']>;
};

export type CheckoutMethod = {
  __typename?: 'CheckoutMethod';
  name?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['String']['output']>;
};

export type CheckoutNote = {
  __typename?: 'CheckoutNote';
  content?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<CheckoutUser>;
};

export type CheckoutPaymentMethod = {
  __typename?: 'CheckoutPaymentMethod';
  added?: Maybe<Scalars['Date']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
};

export type CheckoutShipping = {
  __typename?: 'CheckoutShipping';
  address?: Maybe<CheckoutAddress>;
  confirmationEmail?: Maybe<CheckoutEmail>;
  date?: Maybe<Scalars['Date']['output']>;
  freeShippingThreshold?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  methods?: Maybe<Array<Maybe<CheckoutMethod>>>;
  price?: Maybe<CheckoutLinePrice>;
  shopCollection?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tracking?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['String']['output']>;
};

export type CheckoutShippingInput = {
  address?: InputMaybe<CheckoutAddressInput>;
  confirmationEmail?: InputMaybe<CheckoutEmailInput>;
  method?: InputMaybe<Scalars['String']['input']>;
  shopCollection?: InputMaybe<Scalars['Boolean']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};

export type CheckoutSpending = {
  __typename?: 'CheckoutSpending';
  amount?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
};

export type CheckoutStock = {
  __typename?: 'CheckoutStock';
  quantity?: Maybe<Scalars['Float']['output']>;
};

export type CheckoutTax = {
  __typename?: 'CheckoutTax';
  amount?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CheckoutTotals = {
  __typename?: 'CheckoutTotals';
  discount?: Maybe<Scalars['Float']['output']>;
  grand?: Maybe<Scalars['Float']['output']>;
  itemQuantity?: Maybe<Scalars['Int']['output']>;
  itemsQuantity?: Maybe<Scalars['Float']['output']>;
  leftToPay?: Maybe<Scalars['Float']['output']>;
  shipping?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  taxes?: Maybe<Array<Maybe<CheckoutTotalsTax>>>;
};

export type CheckoutTotalsTax = {
  __typename?: 'CheckoutTotalsTax';
  amount?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CheckoutUrls = {
  __typename?: 'CheckoutUrls';
  checkout: Scalars['String']['output'];
  storefront: Scalars['String']['output'];
};

export type CheckoutUser = {
  __typename?: 'CheckoutUser';
  _id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  taxNumber?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
};

export type CheckoutVerifyAndUpdateResponse = {
  __typename?: 'CheckoutVerifyAndUpdateResponse';
  checkout?: Maybe<Checkout>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CheckoutVoucher = {
  __typename?: 'CheckoutVoucher';
  created?: Maybe<Scalars['Date']['output']>;
  expires?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  note?: Maybe<CheckoutNote>;
  originalValue?: Maybe<Scalars['String']['output']>;
  redeemType?: Maybe<Scalars['String']['output']>;
  redeemed?: Maybe<Scalars['Boolean']['output']>;
  unlimited?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<CheckoutUser>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CheckoutVoucherInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  redeemType?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Collection = {
  __typename?: 'Collection';
  _id?: Maybe<Scalars['ID']['output']>;
  banner?: Maybe<CollectionBanner>;
  description?: Maybe<CollectionDescription>;
  handle?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<CollectionSort>;
  title?: Maybe<Scalars['String']['output']>;
  viewType?: Maybe<Scalars['String']['output']>;
};

export type CollectionBanner = {
  __typename?: 'CollectionBanner';
  format?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Media>;
};

export type CollectionDescription = {
  __typename?: 'CollectionDescription';
  content?: Maybe<Scalars['String']['output']>;
};

export type CollectionPage = {
  __typename?: 'CollectionPage';
  items: Array<Item>;
  pagination?: Maybe<Pagination>;
};

export type CollectionSort = {
  __typename?: 'CollectionSort';
  key?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type CollectionWithData = {
  __typename?: 'CollectionWithData';
  collection?: Maybe<Collection>;
  page?: Maybe<CollectionPage>;
};

export type Config = {
  __typename?: 'Config';
  _id?: Maybe<Scalars['ID']['output']>;
  apiKey?: Maybe<ConfigApiKey>;
  articles?: Maybe<Array<Maybe<Article>>>;
  /** @deprecated No longer supported */
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated No longer supported */
  categoriesProduct?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  currencySymbolPosition?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  eshop?: Maybe<Eshop>;
  google?: Maybe<Google>;
  id?: Maybe<Scalars['Int']['output']>;
  modules: Array<ConfigModule>;
  /** @deprecated No longer supported */
  productTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shopName?: Maybe<Scalars['String']['output']>;
  sites?: Maybe<Array<ConfigSite>>;
  socials?: Maybe<Array<ConfigSocial>>;
  taxes?: Maybe<ConfigTaxes>;
  uri?: Maybe<Scalars['String']['output']>;
};

export type ConfigApiKey = {
  __typename?: 'ConfigApiKey';
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ConfigEshopHead = {
  __typename?: 'ConfigEshopHead';
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ConfigEshopPreferences = {
  __typename?: 'ConfigEshopPreferences';
  access?: Maybe<ConfigEshopPreferencesAccess>;
  homepage?: Maybe<ConfigEshopPreferencesHomepage>;
  languages?: Maybe<ConfigEshopPreferencesLanguages>;
  player?: Maybe<ConfigEshopPreferencesPlayer>;
  suggestions?: Maybe<ConfigEshopPreferencesSuggestions>;
  wantlist?: Maybe<ConfigEshopPreferencesWantlist>;
};

export type ConfigEshopPreferencesAccess = {
  __typename?: 'ConfigEshopPreferencesAccess';
  maintenance?: Maybe<ConfigEshopPreferencesAccessPrivate>;
  private?: Maybe<ConfigEshopPreferencesAccessPrivate>;
};

export type ConfigEshopPreferencesAccessMaintenance = {
  __typename?: 'ConfigEshopPreferencesAccessMaintenance';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ConfigEshopPreferencesAccessPrivate = {
  __typename?: 'ConfigEshopPreferencesAccessPrivate';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ConfigEshopPreferencesHomepage = {
  __typename?: 'ConfigEshopPreferencesHomepage';
  handle?: Maybe<Scalars['String']['output']>;
  ref?: Maybe<Scalars['ID']['output']>;
  type: Scalars['String']['output'];
};

export type ConfigEshopPreferencesLanguages = {
  __typename?: 'ConfigEshopPreferencesLanguages';
  whitelist?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ConfigEshopPreferencesPlayer = {
  __typename?: 'ConfigEshopPreferencesPlayer';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type ConfigEshopPreferencesSuggestions = {
  __typename?: 'ConfigEshopPreferencesSuggestions';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type ConfigEshopPreferencesWantlist = {
  __typename?: 'ConfigEshopPreferencesWantlist';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type ConfigModule = {
  __typename?: 'ConfigModule';
  data?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type ConfigSite = {
  __typename?: 'ConfigSite';
  domain?: Maybe<Scalars['String']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
};

export type ConfigSocial = {
  __typename?: 'ConfigSocial';
  id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ConfigTaxes = {
  __typename?: 'ConfigTaxes';
  rules?: Maybe<ConfigTaxesRules>;
};

export type ConfigTaxesRules = {
  __typename?: 'ConfigTaxesRules';
  editPricesBeforeTaxes?: Maybe<Scalars['Boolean']['output']>;
  showPricesBeforeTaxes?: Maybe<Scalars['Boolean']['output']>;
};

export type Descriptions = {
  __typename?: 'Descriptions';
  main?: Maybe<Scalars['String']['output']>;
  shop?: Maybe<ShopDescriptions>;
};

export type Eshop = {
  __typename?: 'Eshop';
  checkout?: Maybe<EshopCheckout>;
  head?: Maybe<ConfigEshopHead>;
  menus?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  preferences?: Maybe<ConfigEshopPreferences>;
  theme?: Maybe<ThemeEntry>;
  uri?: Maybe<Scalars['String']['output']>;
};

export type EshopCheckout = {
  __typename?: 'EshopCheckout';
  paymentMethods?: Maybe<EshopCheckoutPaymentMethods>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type EshopCheckoutPaymentIyzipay = {
  __typename?: 'EshopCheckoutPaymentIyzipay';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type EshopCheckoutPaymentMethods = {
  __typename?: 'EshopCheckoutPaymentMethods';
  cashInAdvance?: Maybe<EshopCheckoutPaymentMethodsCashInAdvance>;
  iyzipay?: Maybe<EshopCheckoutPaymentIyzipay>;
  payze?: Maybe<EshopCheckoutPaymentPayze>;
  stripe?: Maybe<EshopCheckoutPaymentStripe>;
};

export type EshopCheckoutPaymentMethodsCashInAdvance = {
  __typename?: 'EshopCheckoutPaymentMethodsCashInAdvance';
  notes?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type EshopCheckoutPaymentPayze = {
  __typename?: 'EshopCheckoutPaymentPayze';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type EshopCheckoutPaymentStripe = {
  __typename?: 'EshopCheckoutPaymentStripe';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  publishableKey?: Maybe<Scalars['String']['output']>;
};

export type Event = {
  __typename?: 'Event';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ref?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Google = {
  __typename?: 'Google';
  analytics?: Maybe<GoogleAnalytics>;
};

export type GoogleAnalytics = {
  __typename?: 'GoogleAnalytics';
  property?: Maybe<GoogleAnatyticsProperty>;
  view?: Maybe<GoogleAnalyticsView>;
};

export type GoogleAnalyticsView = {
  __typename?: 'GoogleAnalyticsView';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GoogleAnatyticsProperty = {
  __typename?: 'GoogleAnatyticsProperty';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tracker?: Maybe<Scalars['String']['output']>;
};

export type Image = {
  __typename?: 'Image';
  alternative?: Maybe<ImageAlternative>;
  uri?: Maybe<Scalars['String']['output']>;
};

export type ImageAlternative = {
  __typename?: 'ImageAlternative';
  uri?: Maybe<Scalars['String']['output']>;
};

export type Inventory = {
  __typename?: 'Inventory';
  filters?: Maybe<Scalars['JSON']['output']>;
  items?: Maybe<Array<Maybe<Item>>>;
  pagination?: Maybe<Pagination>;
};

export type Item = {
  __typename?: 'Item';
  _id: Scalars['ID']['output'];
  bitly?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ItemData>;
  descriptions?: Maybe<Descriptions>;
  handle?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  isForbiddenForSale?: Maybe<Scalars['Boolean']['output']>;
  listings: Array<Listing>;
  path?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  uri?: Maybe<Scalars['String']['output']>;
  wanted?: Maybe<Scalars['Boolean']['output']>;
};

export type ItemArtist = {
  __typename?: 'ItemArtist';
  anv?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  join?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ItemData = {
  __typename?: 'ItemData';
  artists?: Maybe<Array<ItemArtist>>;
  assetLink?: Maybe<Scalars['String']['output']>;
  authors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cat?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Array<Scalars['String']['output']>>;
  country?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  formats?: Maybe<Array<ReleaseFormat>>;
  genres?: Maybe<Array<Scalars['String']['output']>>;
  identifiers?: Maybe<Array<ItemIdentifier>>;
  images: Array<Image>;
  /** @deprecated No longer supported */
  industryIdentifiers?: Maybe<Array<Maybe<BookIndustryIdentifier>>>;
  labels?: Maybe<Array<ItemLabel>>;
  language?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  maturityRating?: Maybe<Scalars['String']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  publishedDate?: Maybe<Scalars['Date']['output']>;
  publisher?: Maybe<Scalars['String']['output']>;
  releaseDate?: Maybe<Scalars['Date']['output']>;
  styles?: Maybe<Array<Scalars['String']['output']>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tracklist?: Maybe<Array<Maybe<Track>>>;
  type?: Maybe<Scalars['String']['output']>;
  videos?: Maybe<Array<Maybe<ItemVideo>>>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ItemIdentifier = {
  __typename?: 'ItemIdentifier';
  description?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ItemLabel = {
  __typename?: 'ItemLabel';
  anv?: Maybe<Scalars['String']['output']>;
  catno?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ItemVideo = {
  __typename?: 'ItemVideo';
  uri?: Maybe<Scalars['String']['output']>;
};

export type Label = {
  __typename?: 'Label';
  _id: Scalars['ID']['output'];
  country?: Maybe<LabelCountry>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  discogsId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  images?: Maybe<Array<Maybe<LabelImage>>>;
  modifiedAt?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Scalars['String']['output']>;
  subLabels?: Maybe<Array<Maybe<LabelSub>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  websites?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type LabelCountry = {
  __typename?: 'LabelCountry';
  alpha2?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LabelImage = {
  __typename?: 'LabelImage';
  thumbnail?: Maybe<Scalars['String']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
};

export type LabelSub = {
  __typename?: 'LabelSub';
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Listing = {
  __typename?: 'Listing';
  _id?: Maybe<Scalars['ID']['output']>;
  available?: Maybe<Scalars['Date']['output']>;
  categories: Array<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  onePerCustomer?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<Option>>>;
  preOrder?: Maybe<Scalars['Boolean']['output']>;
  prices?: Maybe<Prices>;
  secondHand?: Maybe<Scalars['Boolean']['output']>;
  stock?: Maybe<Stock>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  checkout?: Maybe<Checkout>;
  session?: Maybe<Session>;
  sessionsCount?: Maybe<Scalars['Int']['output']>;
};

export type LogoutResponse = {
  __typename?: 'LogoutResponse';
  checkout?: Maybe<Checkout>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type Media = {
  __typename?: 'Media';
  _id?: Maybe<Scalars['ID']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Date']['output']>;
  ext?: Maybe<Scalars['String']['output']>;
  formatArray?: Maybe<Array<MediaFormat>>;
  formats?: Maybe<MediaFormats>;
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  mime?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type MediaFormat = {
  __typename?: 'MediaFormat';
  _id?: Maybe<Scalars['ID']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type MediaFormats = {
  __typename?: 'MediaFormats';
  banner?: Maybe<MediaFormat>;
  large?: Maybe<MediaFormat>;
  small?: Maybe<MediaFormat>;
  square?: Maybe<MediaFormat>;
  thumbnail?: Maybe<MediaFormat>;
};

export type Message = {
  __typename?: 'Message';
  attachments?: Maybe<Array<Maybe<OrderMessageAttachment>>>;
  content?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Date']['output']>;
  fromBuyer?: Maybe<Scalars['Boolean']['output']>;
  sender?: Maybe<OrderMessageSender>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addVoucher?: Maybe<Checkout>;
  buyerDeactivate?: Maybe<Scalars['String']['output']>;
  checkoutAssociateUser?: Maybe<Checkout>;
  checkoutCreate?: Maybe<Checkout>;
  checkoutDisassociateUser?: Maybe<Checkout>;
  checkoutUpdate?: Maybe<Checkout>;
  checkoutUpdateItems?: Maybe<Checkout>;
  checkoutVerifyAndThrow?: Maybe<Checkout>;
  checkoutVerifyAndUpdate?: Maybe<CheckoutVerifyAndUpdateResponse>;
  inventoryFileExport: Scalars['String']['output'];
  itemSnippetsArchive?: Maybe<Scalars['String']['output']>;
  listOptin?: Maybe<Scalars['String']['output']>;
  listOptout?: Maybe<Scalars['String']['output']>;
  login?: Maybe<LoginResponse>;
  logout?: Maybe<LogoutResponse>;
  orderAddMessage?: Maybe<Order>;
  paypalAuthorizePayment?: Maybe<PaypalAuthorizePaymentResponse>;
  paypalCreateOrder?: Maybe<PaypalCreateOrderResponse>;
  playCount?: Maybe<Scalars['String']['output']>;
  register?: Maybe<RegisterResponse>;
  registerEvent?: Maybe<Event>;
  removeVoucher?: Maybe<Checkout>;
  stripeCreateIntent?: Maybe<StripeCreateIntentResponse>;
  submitIndirectPaymentIntent?: Maybe<PaymentIntentRedirectUrl>;
  submitNoPaymentIntent?: Maybe<PaymentIntentRedirectUrl>;
  userCreatePasswordToken?: Maybe<Scalars['String']['output']>;
  userPasswordReset?: Maybe<Scalars['String']['output']>;
  userUpdate?: Maybe<User>;
  userVerify?: Maybe<UserVerifyResponse>;
  userVerifyPasswordToken?: Maybe<User>;
  validateVoucher?: Maybe<CheckoutVoucher>;
  want?: Maybe<Item>;
};


export type MutationAddVoucherArgs = {
  id: Scalars['String']['input'];
  voucherId: Scalars['String']['input'];
};


export type MutationCheckoutAssociateUserArgs = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
};


export type MutationCheckoutDisassociateUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationCheckoutUpdateArgs = {
  billing?: InputMaybe<CheckoutBillingInput>;
  buyer?: InputMaybe<CheckoutBuyerInput>;
  createAccount?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  shipping?: InputMaybe<CheckoutShippingInput>;
};


export type MutationCheckoutUpdateItemsArgs = {
  id: Scalars['String']['input'];
  items?: InputMaybe<Array<InputMaybe<CheckoutItemInput>>>;
};


export type MutationCheckoutVerifyAndThrowArgs = {
  id: Scalars['String']['input'];
};


export type MutationCheckoutVerifyAndUpdateArgs = {
  id: Scalars['String']['input'];
};


export type MutationItemSnippetsArchiveArgs = {
  id: Scalars['Float']['input'];
};


export type MutationListOptinArgs = {
  email: Scalars['String']['input'];
  listRef: Scalars['ID']['input'];
};


export type MutationListOptoutArgs = {
  email: Scalars['String']['input'];
  listRef: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  checkoutId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationLogoutArgs = {
  checkoutId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationOrderAddMessageArgs = {
  id: Scalars['String']['input'];
  message: Scalars['String']['input'];
};


export type MutationPaypalAuthorizePaymentArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  paypalOrderId: Scalars['String']['input'];
};


export type MutationPaypalCreateOrderArgs = {
  documentId: Scalars['String']['input'];
};


export type MutationPlayCountArgs = {
  id: Scalars['Float']['input'];
  position: Scalars['String']['input'];
};


export type MutationRegisterArgs = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  withVerificationCode?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRegisterEventArgs = {
  data: Scalars['JSON']['input'];
  type: Scalars['String']['input'];
};


export type MutationRemoveVoucherArgs = {
  id: Scalars['String']['input'];
};


export type MutationStripeCreateIntentArgs = {
  documentId: Scalars['String']['input'];
};


export type MutationSubmitIndirectPaymentIntentArgs = {
  billingType: Scalars['String']['input'];
  checkoutId: Scalars['String']['input'];
};


export type MutationSubmitNoPaymentIntentArgs = {
  checkoutId: Scalars['String']['input'];
};


export type MutationUserCreatePasswordTokenArgs = {
  email: Scalars['String']['input'];
  withVerificationCode?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUserPasswordResetArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationUserUpdateArgs = {
  addresses?: InputMaybe<Array<InputMaybe<AddressInput>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organisation?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  preferences?: InputMaybe<Scalars['JSON']['input']>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserVerifyArgs = {
  checkoutId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserVerifyPasswordTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationValidateVoucherArgs = {
  id: Scalars['String']['input'];
  voucherId: Scalars['String']['input'];
};


export type MutationWantArgs = {
  id: Scalars['Float']['input'];
};

export type Option = {
  __typename?: 'Option';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Order = {
  __typename?: 'Order';
  _id?: Maybe<Scalars['ID']['output']>;
  billing?: Maybe<CheckoutBilling>;
  buyer?: Maybe<CheckoutBuyer>;
  configRef?: Maybe<Scalars['ID']['output']>;
  created?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  items: Array<CheckoutLineItem>;
  messages?: Maybe<Array<Maybe<Message>>>;
  origin?: Maybe<Scalars['String']['output']>;
  paymentUrl?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<CheckoutShipping>;
  status?: Maybe<Scalars['String']['output']>;
  totals?: Maybe<CheckoutTotals>;
};

export type OrderMessageAttachment = {
  __typename?: 'OrderMessageAttachment';
  _id?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
};

export type OrderMessageSender = {
  __typename?: 'OrderMessageSender';
  alias?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  count?: Maybe<Scalars['Int']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  pages?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<Scalars['String']['output']>;
};

export type PaymentCreateResponse = {
  __typename?: 'PaymentCreateResponse';
  data?: Maybe<Scalars['JSON']['output']>;
  paymentUrl?: Maybe<Scalars['String']['output']>;
};

export type PaymentIntentRedirectUrl = {
  __typename?: 'PaymentIntentRedirectUrl';
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

export type PaypalAuthorizePaymentResponse = {
  __typename?: 'PaypalAuthorizePaymentResponse';
  /** @deprecated No longer supported */
  authorizationId?: Maybe<Scalars['String']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

export type PaypalCreateOrderResponse = {
  __typename?: 'PaypalCreateOrderResponse';
  orderId?: Maybe<Scalars['String']['output']>;
};

export type Playlist = {
  __typename?: 'Playlist';
  _id: Scalars['ID']['output'];
  entries?: Maybe<Array<Maybe<PlaylistEntry>>>;
  id?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Maybe<Item>>>;
  link?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PlaylistEntry = {
  __typename?: 'PlaylistEntry';
  comments?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Item>;
};

export type Prices = {
  __typename?: 'Prices';
  beforeTaxes?: Maybe<Scalars['Float']['output']>;
  compare?: Maybe<Scalars['Float']['output']>;
  sale?: Maybe<Scalars['Float']['output']>;
};

export type Query = {
  __typename?: 'Query';
  article?: Maybe<Article>;
  articles?: Maybe<Array<Article>>;
  artists?: Maybe<Array<Maybe<Artist>>>;
  checkout?: Maybe<Checkout>;
  collection?: Maybe<CollectionWithData>;
  config?: Maybe<Config>;
  countries?: Maybe<Scalars['JSON']['output']>;
  inventory?: Maybe<Inventory>;
  item?: Maybe<Item>;
  items?: Maybe<Array<Maybe<Item>>>;
  labels?: Maybe<Array<Maybe<Label>>>;
  order?: Maybe<Order>;
  orders?: Maybe<Array<Maybe<Order>>>;
  paymentUrl?: Maybe<PaymentCreateResponse>;
  playlist?: Maybe<Playlist>;
  search?: Maybe<SearchResponse>;
  session?: Maybe<Session>;
  suggestions?: Maybe<Array<Maybe<Item>>>;
  theme?: Maybe<Theme>;
  user?: Maybe<User>;
  userPasswordSession?: Maybe<User>;
};


export type QueryArticleArgs = {
  handle?: InputMaybe<Scalars['String']['input']>;
  homepage?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryArticlesArgs = {
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryArtistsArgs = {
  letter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheckoutArgs = {
  id: Scalars['String']['input'];
};


export type QueryCollectionArgs = {
  handle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  randomise?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryConfigArgs = {
  configRef?: InputMaybe<Scalars['ID']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  themeRef?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryInventoryArgs = {
  artists?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  condition?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formats?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  from?: InputMaybe<Scalars['String']['input']>;
  genres?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  manufacturers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  maxPrice?: InputMaybe<Scalars['Int']['input']>;
  mediums?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  noFilters?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preorder?: InputMaybe<Scalars['Boolean']['input']>;
  preorders?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  stock?: InputMaybe<Scalars['String']['input']>;
  styles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  to?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wantlist?: InputMaybe<Scalars['Boolean']['input']>;
  years?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryItemArgs = {
  id?: InputMaybe<Scalars['Float']['input']>;
  itemRef?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryItemsArgs = {
  ids: Array<InputMaybe<Scalars['Float']['input']>>;
};


export type QueryLabelsArgs = {
  letter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrderArgs = {
  id: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPaymentUrlArgs = {
  documentId: Scalars['String']['input'];
  processor: Scalars['String']['input'];
};


export type QueryPlaylistArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySearchArgs = {
  term: Scalars['String']['input'];
};


export type QuerySuggestionsArgs = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country?: InputMaybe<Scalars['String']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  genres?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
  styles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryThemeArgs = {
  id: Scalars['String']['input'];
};


export type QueryUserPasswordSessionArgs = {
  token: Scalars['String']['input'];
};

export type RegisterResponse = {
  __typename?: 'RegisterResponse';
  message?: Maybe<Scalars['String']['output']>;
  session?: Maybe<Session>;
  user: User;
};

export type ReleaseFormat = {
  __typename?: 'ReleaseFormat';
  descriptions: Array<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  qty?: Maybe<Scalars['String']['output']>;
};

export type SearchResponse = {
  __typename?: 'SearchResponse';
  items?: Maybe<Array<Maybe<Item>>>;
};

export type Seo = {
  __typename?: 'Seo';
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Boolean']['output']>;
};

export type Session = {
  __typename?: 'Session';
  expires?: Maybe<Scalars['Date']['output']>;
  jwt: Scalars['String']['output'];
  user?: Maybe<User>;
};

export type ShopDescriptions = {
  __typename?: 'ShopDescriptions';
  html?: Maybe<Scalars['String']['output']>;
  short?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type Stock = {
  __typename?: 'Stock';
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type StripeCreateIntentResponse = {
  __typename?: 'StripeCreateIntentResponse';
  intent?: Maybe<Scalars['JSON']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  results?: Maybe<StripeIntentResults>;
};

export type StripeIntentResults = {
  __typename?: 'StripeIntentResults';
  error?: Maybe<Scalars['String']['output']>;
  payment_intent_client_secret?: Maybe<Scalars['String']['output']>;
  requires_action?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Theme = {
  __typename?: 'Theme';
  _id?: Maybe<Scalars['ID']['output']>;
  buttons?: Maybe<ThemeButtons>;
  colors?: Maybe<ThemeColors>;
  /** @deprecated No longer supported */
  colours?: Maybe<ThemeColors>;
  css?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fontFaces?: Maybe<Scalars['String']['output']>;
  fontSizes?: Maybe<ThemeResponsiveData>;
  icons?: Maybe<ThemeIcons>;
  id?: Maybe<Scalars['Int']['output']>;
  miscs?: Maybe<Array<Maybe<ThemeEntryValue>>>;
  pages?: Maybe<ThemePages>;
  player?: Maybe<ThemePlayer>;
  settings?: Maybe<ThemeSettings>;
  spacings?: Maybe<ThemeResponsiveData>;
  styles: Array<ThemeStyle>;
  stylesheet?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
  views?: Maybe<ThemeViews>;
};

export type ThemeButton = {
  __typename?: 'ThemeButton';
  backgroundColor?: Maybe<ThemeButtonsBackgroundColor>;
  border?: Maybe<ThemeButtonsBorder>;
  padding?: Maybe<ThemeButtonsPadding>;
};

export type ThemeButtons = {
  __typename?: 'ThemeButtons';
  addToBasket?: Maybe<ThemeButtonsAddToBasket>;
  buy?: Maybe<ThemeButton>;
  primary?: Maybe<ThemeButton>;
};

export type ThemeButtonsAddToBasket = {
  __typename?: 'ThemeButtonsAddToBasket';
  withQuantity?: Maybe<Scalars['Boolean']['output']>;
};

export type ThemeButtonsBackgroundColor = {
  __typename?: 'ThemeButtonsBackgroundColor';
  active?: Maybe<ThemeColorPreset>;
  default?: Maybe<ThemeColorPreset>;
  hover?: Maybe<ThemeColorPreset>;
};

export type ThemeButtonsBorder = {
  __typename?: 'ThemeButtonsBorder';
  color?: Maybe<ThemeButtonsBorderColor>;
  radius?: Maybe<Scalars['Int']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type ThemeButtonsBorderColor = {
  __typename?: 'ThemeButtonsBorderColor';
  active?: Maybe<ThemeColorPreset>;
  default?: Maybe<ThemeColorPreset>;
  hover?: Maybe<ThemeColorPreset>;
};

export type ThemeButtonsPadding = {
  __typename?: 'ThemeButtonsPadding';
  horizontal?: Maybe<Scalars['Int']['output']>;
  vertical?: Maybe<Scalars['Int']['output']>;
};

export type ThemeColorPreset = {
  __typename?: 'ThemeColorPreset';
  _id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ThemeColors = {
  __typename?: 'ThemeColors';
  areas?: Maybe<Array<Maybe<ThemeEntryValue>>>;
  presets?: Maybe<Array<Maybe<ThemeColorPreset>>>;
  primary?: Maybe<Scalars['String']['output']>;
  secondary?: Maybe<Scalars['String']['output']>;
};

export type ThemeEntry = {
  __typename?: 'ThemeEntry';
  selected?: Maybe<Theme>;
};

export type ThemeEntryCollectionColumns = {
  __typename?: 'ThemeEntryCollectionColumns';
  desktop?: Maybe<Scalars['Int']['output']>;
  mobile?: Maybe<Scalars['Int']['output']>;
  tablet?: Maybe<Scalars['Int']['output']>;
};

export type ThemeEntryValue = {
  __typename?: 'ThemeEntryValue';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ThemeIcons = {
  __typename?: 'ThemeIcons';
  fontUri?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ThemeLayout = {
  __typename?: 'ThemeLayout';
  id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ThemePages = {
  __typename?: 'ThemePages';
  item?: Maybe<ThemePagesItem>;
};

export type ThemePagesItem = {
  __typename?: 'ThemePagesItem';
  layout?: Maybe<ThemeLayout>;
  /** @deprecated No longer supported */
  suggestions?: Maybe<ThemePagesItemSuggestions>;
};

export type ThemePagesItemSuggestions = {
  __typename?: 'ThemePagesItemSuggestions';
  display?: Maybe<Scalars['Boolean']['output']>;
};

export type ThemePlayer = {
  __typename?: 'ThemePlayer';
  /** @deprecated No longer supported */
  active?: Maybe<Scalars['Boolean']['output']>;
  backgroundColor?: Maybe<ThemeColorPreset>;
  barGap?: Maybe<Scalars['Int']['output']>;
  barRadius?: Maybe<Scalars['Int']['output']>;
  barWidth?: Maybe<Scalars['Int']['output']>;
  cursorColor?: Maybe<ThemeColorPreset>;
  cursorWidth?: Maybe<Scalars['Int']['output']>;
  progressColor?: Maybe<ThemeColorPreset>;
  waveformColor?: Maybe<ThemeColorPreset>;
};

export type ThemeResponsiveData = {
  __typename?: 'ThemeResponsiveData';
  desktop?: Maybe<Array<Maybe<ThemeEntryValue>>>;
  mobile?: Maybe<Array<Maybe<ThemeEntryValue>>>;
};

export type ThemeSettings = {
  __typename?: 'ThemeSettings';
  backgroundColor?: Maybe<ThemeColorPreset>;
  borderRadius?: Maybe<Scalars['Int']['output']>;
  carousel?: Maybe<ThemeSettingsCarousel>;
  collectionColumns?: Maybe<ThemeEntryCollectionColumns>;
  footer?: Maybe<ThemeSettingsFooter>;
  gutter?: Maybe<ThemeSettingsGutter>;
  header?: Maybe<ThemeSettingsHeader>;
  layout?: Maybe<ThemeLayout>;
  /** @deprecated No longer supported */
  logo?: Maybe<ThemeSettingsLogo>;
  maxWidth?: Maybe<Scalars['Int']['output']>;
  mobileBreakpoint?: Maybe<Scalars['Int']['output']>;
  navbar?: Maybe<ThemeSettingsNavbar>;
  superHeader?: Maybe<ThemeSettingsSuperHeader>;
  /** @deprecated No longer supported */
  wantlist?: Maybe<ThemeSettingsWantlist>;
};

export type ThemeSettingsCarousel = {
  __typename?: 'ThemeSettingsCarousel';
  transitionType?: Maybe<Scalars['String']['output']>;
};

export type ThemeSettingsFooter = {
  __typename?: 'ThemeSettingsFooter';
  backgroundColor?: Maybe<ThemeColorPreset>;
  layout?: Maybe<ThemeLayout>;
};

export type ThemeSettingsGutter = {
  __typename?: 'ThemeSettingsGutter';
  desktop?: Maybe<Scalars['Int']['output']>;
  mobile?: Maybe<Scalars['Int']['output']>;
  tablet?: Maybe<Scalars['Int']['output']>;
};

export type ThemeSettingsHeader = {
  __typename?: 'ThemeSettingsHeader';
  backgroundColor?: Maybe<ThemeColorPreset>;
  layout?: Maybe<ThemeLayout>;
  logoWidth?: Maybe<ThemeSettingsHeaderLogoWidth>;
  sticky?: Maybe<Scalars['Boolean']['output']>;
};

export type ThemeSettingsHeaderLogoWidth = {
  __typename?: 'ThemeSettingsHeaderLogoWidth';
  desktop?: Maybe<Scalars['Int']['output']>;
  mobile?: Maybe<Scalars['Int']['output']>;
  tablet?: Maybe<Scalars['Int']['output']>;
};

export type ThemeSettingsLogo = {
  __typename?: 'ThemeSettingsLogo';
  width?: Maybe<Scalars['Int']['output']>;
};

export type ThemeSettingsNavbar = {
  __typename?: 'ThemeSettingsNavbar';
  layout?: Maybe<ThemeLayout>;
};

export type ThemeSettingsSuperHeader = {
  __typename?: 'ThemeSettingsSuperHeader';
  backgroundColor?: Maybe<ThemeColorPreset>;
  display?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ThemeSettingsWantlist = {
  __typename?: 'ThemeSettingsWantlist';
  /** @deprecated No longer supported */
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type ThemeStyle = {
  __typename?: 'ThemeStyle';
  _id?: Maybe<Scalars['ID']['output']>;
  css?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ThemeViews = {
  __typename?: 'ThemeViews';
  full?: Maybe<ThemeViewsFull>;
};

export type ThemeViewsFull = {
  __typename?: 'ThemeViewsFull';
  imagesAsCarousel?: Maybe<Scalars['Boolean']['output']>;
};

export type Track = {
  __typename?: 'Track';
  artists: Array<ItemArtist>;
  duration?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type_?: Maybe<Scalars['String']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
};

export type User = {
  __typename?: 'User';
  _id?: Maybe<Scalars['ID']['output']>;
  addresses?: Maybe<Array<Maybe<UserAddress>>>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  isSubscribed?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organisation?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<UserPreferences>;
  taxNumber?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
};

export type UserAddress = {
  __typename?: 'UserAddress';
  _id?: Maybe<Scalars['ID']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  alpha2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type UserPreferences = {
  __typename?: 'UserPreferences';
  notifications?: Maybe<UserPreferencesNotifications>;
  preferredLanguage?: Maybe<Scalars['String']['output']>;
};

export type UserPreferencesNotifications = {
  __typename?: 'UserPreferencesNotifications';
  backInStock?: Maybe<UserPreferencesNotificationsBackInStock>;
};

export type UserPreferencesNotificationsBackInStock = {
  __typename?: 'UserPreferencesNotificationsBackInStock';
  email?: Maybe<Scalars['Boolean']['output']>;
};

export type UserVerifyResponse = {
  __typename?: 'UserVerifyResponse';
  checkout?: Maybe<Checkout>;
  message?: Maybe<Scalars['String']['output']>;
  session?: Maybe<Session>;
};

export type AddToWantlistMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type AddToWantlistMutation = { __typename?: 'Mutation', want?: (
    { __typename?: 'Item' }
    & { ' $fragmentRefs'?: { 'ItemFieldsFragment': ItemFieldsFragment } }
  ) | null };

export type ItemFieldsFragment = { __typename?: 'Item', id?: number | null, type: string, path?: string | null, wanted?: boolean | null, uri?: string | null, isForbiddenForSale?: boolean | null, listings: Array<{ __typename?: 'Listing', id?: number | null, available?: any | null, preOrder?: boolean | null, secondHand?: boolean | null, onePerCustomer?: boolean | null, comments?: string | null, stock?: { __typename?: 'Stock', quantity?: number | null } | null, prices?: { __typename?: 'Prices', beforeTaxes?: number | null, sale?: number | null, compare?: number | null } | null, options?: Array<{ __typename?: 'Option', name?: string | null, value?: string | null } | null> | null }>, descriptions?: { __typename?: 'Descriptions', main?: string | null, shop?: { __typename?: 'ShopDescriptions', text?: string | null, html?: string | null, short?: string | null } | null } | null, data?: { __typename?: 'ItemData', title?: string | null, assetLink?: string | null, weight?: number | null, genres?: Array<string> | null, styles?: Array<string> | null, manufacturer?: string | null, cat?: string | null, releaseDate?: any | null, country?: string | null, subtitle?: string | null, authors?: Array<string | null> | null, publisher?: string | null, publishedDate?: any | null, pageCount?: number | null, categories?: Array<string> | null, maturityRating?: string | null, language?: string | null, identifiers?: Array<{ __typename?: 'ItemIdentifier', type?: string | null, value?: string | null }> | null, images: Array<{ __typename?: 'Image', uri?: string | null, alternative?: { __typename?: 'ImageAlternative', uri?: string | null } | null }>, tracklist?: Array<{ __typename?: 'Track', type_?: string | null, title?: string | null, uri?: string | null, duration?: string | null, position?: string | null, artists: Array<{ __typename?: 'ItemArtist', name?: string | null, id?: number | null, anv?: string | null }> } | null> | null, formats?: Array<{ __typename?: 'ReleaseFormat', descriptions: Array<string>, name?: string | null, qty?: string | null }> | null, artists?: Array<{ __typename?: 'ItemArtist', name?: string | null, anv?: string | null, id?: number | null, join?: string | null }> | null, labels?: Array<{ __typename?: 'ItemLabel', name?: string | null, id?: number | null, catno?: string | null }> | null, videos?: Array<{ __typename?: 'ItemVideo', uri?: string | null } | null> | null } | null } & { ' $fragmentName'?: 'ItemFieldsFragment' };

export const ItemFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"wanted"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"isForbiddenForSale"}},{"kind":"Field","name":{"kind":"Name","value":"listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"preOrder"}},{"kind":"Field","name":{"kind":"Name","value":"secondHand"}},{"kind":"Field","name":{"kind":"Name","value":"stock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeTaxes"}},{"kind":"Field","name":{"kind":"Name","value":"sale"}},{"kind":"Field","name":{"kind":"Name","value":"compare"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onePerCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"}}]}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"main"}},{"kind":"Field","name":{"kind":"Name","value":"shop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"short"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"identifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"alternative"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetLink"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"genres"}},{"kind":"Field","name":{"kind":"Name","value":"styles"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"cat"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"tracklist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type_"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"artists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"anv"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"descriptions"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"qty"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"artists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"anv"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"join"}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"catno"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"authors"}},{"kind":"Field","name":{"kind":"Name","value":"publisher"}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}},{"kind":"Field","name":{"kind":"Name","value":"pageCount"}},{"kind":"Field","name":{"kind":"Name","value":"categories"}},{"kind":"Field","name":{"kind":"Name","value":"maturityRating"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]} as unknown as DocumentNode<ItemFieldsFragment, unknown>;
export const AddToWantlistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addToWantlist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"want"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"wanted"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"isForbiddenForSale"}},{"kind":"Field","name":{"kind":"Name","value":"listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"preOrder"}},{"kind":"Field","name":{"kind":"Name","value":"secondHand"}},{"kind":"Field","name":{"kind":"Name","value":"stock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeTaxes"}},{"kind":"Field","name":{"kind":"Name","value":"sale"}},{"kind":"Field","name":{"kind":"Name","value":"compare"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onePerCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"}}]}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"main"}},{"kind":"Field","name":{"kind":"Name","value":"shop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"short"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"identifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"alternative"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetLink"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"genres"}},{"kind":"Field","name":{"kind":"Name","value":"styles"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"cat"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"tracklist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type_"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"artists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"anv"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"descriptions"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"qty"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"artists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"anv"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"join"}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"catno"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"authors"}},{"kind":"Field","name":{"kind":"Name","value":"publisher"}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}},{"kind":"Field","name":{"kind":"Name","value":"pageCount"}},{"kind":"Field","name":{"kind":"Name","value":"categories"}},{"kind":"Field","name":{"kind":"Name","value":"maturityRating"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]} as unknown as DocumentNode<AddToWantlistMutation, AddToWantlistMutationVariables>;